module.exports = __webpack_public_path__ + "static/img/5.351b9472.png";